import { useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { AdCard } from '@/components/marketplace/AdCard';

export const SimilarProductsCarousel = ({ ads, title = 'Quienes vieron este producto también compraron...' }) => {
    const ref = useRef(null);
    if (!ads || ads.length === 0) return null;

    const scroll = (dir) => {
        if (!ref.current) return;
        const step = ref.current.clientWidth * 0.8;
        ref.current.scrollBy({ left: dir * step, behavior: 'smooth' });
    };

    return (
        <section className="mt-10" data-testid="similar-products-carousel">
            <div className="flex items-baseline justify-between mb-4">
                <h2 className="text-lg sm:text-xl font-semibold tracking-tight">{title}</h2>
                <div className="hidden sm:flex items-center gap-2">
                    <button onClick={() => scroll(-1)} className="h-9 w-9 rounded-full border bg-white hover:bg-secondary flex items-center justify-center" aria-label="anterior"><ChevronLeft className="h-4 w-4" /></button>
                    <button onClick={() => scroll(1)} className="h-9 w-9 rounded-full border bg-white hover:bg-secondary flex items-center justify-center" aria-label="siguiente"><ChevronRight className="h-4 w-4" /></button>
                </div>
            </div>
            <div ref={ref} className="flex gap-3 sm:gap-4 overflow-x-auto pb-2 snap-x scroll-smooth" style={{ scrollbarWidth: 'thin' }}>
                {ads.map(a => (
                    <div key={a.id} className="snap-start shrink-0 w-40 sm:w-48 lg:w-56">
                        <AdCard ad={a} />
                    </div>
                ))}
            </div>
        </section>
    );
};
